"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModulePropertiesCacheFileSchema = exports.ModulePropertiesCacheEntrySchema = exports.ModulePropertiesCacheInstanceSchema = exports.MODULE_PROPERTIES_CACHE_SCHEMA_VERSION = void 0;
const zod_1 = require("zod");
const ModelBase_1 = require("./ModelBase");
const metadata_1 = require("./metadata");
const ModuleDrawProperty_1 = require("./DrawingModels/ModuleDrawProperty");
const CadTool_1 = require("./CadTool");
exports.MODULE_PROPERTIES_CACHE_SCHEMA_VERSION = 2;
exports.ModulePropertiesCacheInstanceSchema = zod_1.z.object({
    designId: zod_1.z.string(),
    designModelType: ModelBase_1.ModelTypeSchema,
    ref: zod_1.z.string(),
    drawProperties: zod_1.z.record(zod_1.z.string(), ModuleDrawProperty_1.ModuleDrawPropertySchema),
});
exports.ModulePropertiesCacheEntrySchema = zod_1.z.object({
    name: zod_1.z.string(),
    value: zod_1.z.string().optional(),
    metadata: metadata_1.MetadataSchema.optional(),
    instances: exports.ModulePropertiesCacheInstanceSchema.array(),
});
exports.ModulePropertiesCacheFileSchema = zod_1.z.object({
    projectModelId: zod_1.z.string(),
    schemaVersion: zod_1.z.literal(exports.MODULE_PROPERTIES_CACHE_SCHEMA_VERSION),
    generatedAt: zod_1.z.string(),
    cadTool: CadTool_1.CadToolSchema,
    entries: exports.ModulePropertiesCacheEntrySchema.array(),
});
//# sourceMappingURL=ModulePropertiesCacheFile.js.map